import { createFileRoute } from "@tanstack/react-router";
import Medarbetare from "@/pages/Medarbetare";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildCollectionSchema, buildPageSchema, buildPersonSchemas, buildSeoHead, publicPageSeo } from "@/data/seo";
import { employees } from "@/data/site";

export const Route = createFileRoute("/medarbetare")({
  head: () =>
    buildSeoHead(publicPageSeo.medarbetare, [
      buildPageSchema(publicPageSeo.medarbetare, "CollectionPage"),
      buildCollectionSchema(
        publicPageSeo.medarbetare,
        employees.map((employee) => employee.name),
      ),
      ...buildPersonSchemas(),
      buildBreadcrumbSchema(getBreadcrumbTrail("/medarbetare") ?? []),
    ]),
  component: Medarbetare,
});
